import { render } from "./menu.vue?vue&type=template&id=382bae36&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=382bae36&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382bae36"],['__file',"src/components/public/menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "382bae36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('382bae36', __exports__)) {
    console.log('reload')
    api.reload('382bae36', __exports__)
  }
  
  module.hot.accept("./menu.vue?vue&type=template&id=382bae36&scoped=true", () => {
    console.log('re-render')
    api.rerender('382bae36', render)
  })

}


export default __exports__